import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  constructor() {}

  splitUrlByParams = (fullUrl: string) => {
    const [mainUrl, queryParams] = fullUrl.split("?");
    const queryString = "?" + queryParams || "";

    return [mainUrl, queryString];
  };

  splitUrlByPath = (fullUrl: string) => {
    const url = fullUrl.split("/");

    return url;

    // return [mainUrl, queryString];
  };

  mapToObject = (
    userAttributes: Array<{ Name: string; Value: string }> | undefined,
  ) => {
    return userAttributes?.reduce((acc: any, { Name, Value }) => {
      acc[Name] = Value;
      return acc;
    }, {});
  };

  createCouchDBName = (username: string) => {
    return `userdb-${this.usernameToCouchDBHex(username)}`;
  };

  private usernameToCouchDBHex = (username: string) => {
    const encoder = new TextEncoder();
    const rb = encoder.encode(username);

    let r = "";
    for (const b of rb) {
      r += "0" + b.toString(16).slice(-2);
    }
    return r;
  };
}
